import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsBikeNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5 5h7v2.5h-1.703l.858 1.502a1.26 1.26 0 01.07-.002h8.563l-.943-2.27A1.25 1.25 0 0120 5h5.5a3.5 3.5 0 110 7H25V9.5h.5a1 1 0 100-2h-3.628l2.337 5.628a6.5 6.5 0 11-2.309.959L20.784 11.4l-5.097 8.968A1.25 1.25 0 0114.6 21h-1.774a6.5 6.5 0 11-4.495-7.739l1.107-2.225L7.418 7.5H5zm5.93 8.649L8.519 18.5h5.185zm4.294 2.474l2.628-4.623h-5.27zM6.5 15.5a4 4 0 103.71 5.5H6.5a1.25 1.25 0 01-1.12-1.807l1.808-3.634a4.025 4.025 0 00-.688-.06zm16.389.97a4 4 0 102.309-.958l1.936 4.663-2.31.959z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsBikeNormalMedium;
